var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { locationShape } from 'tss-core-lib-common';

var HistoryStack = function (_Component) {
  _inherits(HistoryStack, _Component);

  function HistoryStack(props) {
    _classCallCheck(this, HistoryStack);

    var _this = _possibleConstructorReturn(this, (HistoryStack.__proto__ || Object.getPrototypeOf(HistoryStack)).call(this, props));

    _this.history = [];
    _this.state = { back: false };
    return _this;
  }

  _createClass(HistoryStack, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Very naïve solution for now. Will always work if child urls are constructed in an add-on fashion
      this.setState({
        back: nextProps.location.pathname.length < this.props.location.pathname.length
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.render(this.state);
    }
  }]);

  return HistoryStack;
}(Component);

HistoryStack.propTypes = {
  render: PropTypes.func.isRequired,
  location: locationShape.isRequired
};
HistoryStack.defaultProps = {};


export default withRouter(HistoryStack);